// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import * as yup from 'yup-legacy';
import { TicketCategorySchemaType, TicketDetailsSchemaType } from './types';

export const categorySchema = yup.object().shape<TicketCategorySchemaType>({
  category: yup.string().required(),
});

export const ticketDetailsSchemaEmployee = yup
  .object()
  .shape<TicketDetailsSchemaType>({
    issue: yup.string().required(),
    details: yup.string(),
    shareWithManager: yup.boolean().default(false),
    stayAnonymous: yup.boolean().default(false),
  });

export const ticketDetailsSchemaManager = yup
  .object()
  .shape<TicketDetailsSchemaType>({
    employee: yup.string().required(),
    issue: yup.string().required(),
    details: yup.string(),
  });
